// extracted by mini-css-extract-plugin
module.exports = {"header":"MeasureImpact_header__RYSEl","p":"MeasureImpact_p__1dKxe"};